// removed by extract-text-webpack-plugin
module.exports = {"hiddenTabs":"_3mQPW59_","collapse":"_10wtOI_U","button":"_2A-04crB"};


//////////////////
// WEBPACK FOOTER
// ./app/account/containers/activate/activate.component.scss
// module id = 370
// module chunks = 0